export const formValidation = {
    hasUploadedFile(container) {
        const uploader =
            container?.querySelector(
                '[data-drupal-selector="edit-field-upload-resource"]'
            ) ||
            document.querySelector(
                '[data-drupal-selector="edit-field-upload-resource"]'
            );

        if (!uploader) return true;

        return Boolean(uploader.querySelector('.uppy-Dashboard-Item.is-complete'));
    },

    isFieldRequired(field) {
        if (
            field.hasAttribute('required') ||
            field.getAttribute('aria-required') === 'true' ||
            field.closest('.js-form-item')?.classList.contains('form-item--required') ||
            field.closest('.form-item')?.classList.contains('form-item--required')
        ) {
            return true;
        }

        const fieldset = field.closest('fieldset');
        if (fieldset) {
            return (
                fieldset.hasAttribute('required') ||
                fieldset.getAttribute('aria-required') === 'true' ||
                fieldset.classList.contains('required')
            );
        }

        return false;
    },

    isFieldFilled(field) {
        const tagName = field.tagName.toLowerCase();
        const type = field.type?.toLowerCase();

        if (field.disabled || field.hidden || field.offsetParent === null) {
            return true;
        }

        if (tagName === 'select') {
            return field.value !== '' && field.value !== '_none';
        }

        if (tagName === 'textarea') {
            return field.value.trim() !== '';
        }

        if (tagName === 'input') {
            if (type === 'checkbox') {
                const name = field.name;
                if (name) {
                    const baseName = name.replace(/\[\d+\]$/, '');
                    const checkboxGroup = document.querySelectorAll(
                        `input[type="checkbox"][name^="${baseName}"]`
                    );
                    if (checkboxGroup.length > 1) {
                        return Array.from(checkboxGroup).some((cb) => cb.checked);
                    }
                }
                return field.checked;
            }

            if (type === 'radio') {
                const name = field.name;
                if (name) {
                    return document.querySelector(`input[name="${name}"]:checked`) !== null;
                }
                return field.checked;
            }

            if (type === 'file') {
                return field.files && field.files.length > 0;
            }

            return field.value.trim() !== '';
        }

        return true;
    },

    getRequiredFields(container) {
        const fields = container.querySelectorAll(
            'input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea'
        );

        const requiredFields = Array.from(fields).filter((field) => this.isFieldRequired(field));

        const seenGroups = new Set();
        return requiredFields.filter((field) => {
            const type = field.type?.toLowerCase();
            if (type === 'radio' || type === 'checkbox') {
                const name = field.name;
                // Unnamed checkboxes (e.g. the "All grades" toggle) are UI
                // helpers that never submit, so they can't satisfy a field.
                if (!name) {
                    return false;
                }
                const baseName = name.replace(/\[\d+\]$/, '');
                if (seenGroups.has(baseName)) {
                    return false;
                }
                seenGroups.add(baseName);
            }
            return true;
        });
    },

    areAllRequiredFieldsFilled(container) {
        const requiredFields = this.getRequiredFields(container);
        return requiredFields.every((field) => this.isFieldFilled(field));
    },

    validateForm(stepElements) {
        const allFilled = stepElements.every((step) =>
            this.areAllRequiredFieldsFilled(step)
        );

        const hasFile = stepElements.some((step) => this.hasUploadedFile(step));

        return allFilled && hasFile;
    },

    observeFormChanges(container, callback) {
        const fields = container.querySelectorAll(
            'input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea'
        );

        fields.forEach((field) => {
            field.addEventListener('input', callback);
            field.addEventListener('change', callback);
        });

        // "All grades" checks grades after 'change' listeners have run.
        container.addEventListener('resourceform:grades-changed', callback);

        const uploader = container.querySelector(
            '[data-drupal-selector="edit-field-upload-resource"]'
        );

        if (uploader) {
            const observer = new MutationObserver(callback);
            observer.observe(uploader, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });
            return observer;
        }

        return null;
    }
};
